export default {
  name: '技术服务',
  children: [
    {
      menuId: 1,
      name: '技术需求',
      url: 'demand',
    },
    {
      menuId: 2,
      name: '协创资源',
      url: 'cocreation',
    },
    {
      menuId: 3,
      name: '标准服务',
      url: 'standard',
    },
  ],
}
